// extracted by css-extract-rspack-plugin
export default {"container":"container-ffEk16","price":"price-SYY9xh","ctaButton":"ctaButton-_DVIz8"};